<template>
	<button
		class="inline-flex items-center whitespace-nowrap hover:opacity-90 border-0 outline-0 bg-transparent cursor-pointer"
		@click="openCallUsModal">
		<span class="mr-8"><svg-icon name="phone-outline" class="iconSize-24"/></span>
		<span class="mr-4 font-bold">{{ contactPoint.areaServed }}</span>
		<span>{{ showContactNumber }}</span>
		<span><svg-icon name="triangleDown" class="iconSize-24 opacity-50"/></span>
	</button>
</template>

<script>
import { contactPointService, nz } from "~/static/data/contactPoint"
import { UserType } from "~/assets/scripts/valueObjects/UserType"

export default {
	data() {
		return {
			contactPoint: nz
		}
	},
	computed: {
		showContactNumber() {
			contactPointService.getActiveCampaignPhoneNumbers(this);

			const { userType } = this.$store.state.authentication.user
			if (userType === UserType.Agent) {
				return this.contactPoint.agent.number;
			} else if (userType === UserType.Corporate) {
				return this.contactPoint.corporate.number;
			}
			return this.contactPoint.number;
		}
	},
	methods: {
		async openCallUsModal() {
			const { default: callUsModal } = await import("~/components/modals/callUs.vue")
			this.$modalService.show(callUsModal)
		},
	},
};
</script>
